import omit from "lodash/omit";
import { slugify } from "rizzo-next/dist/core/utils/stringHelpers";

const _ = {
  omit,
};

export const createAdTargeting = (udo = {}) => {
  if (Object.keys(udo).length) {
    const dest = [
      "cd1_Continent",
      "cd2_Country",
      "cd3_City",
      "cd4_Neighborhood",
      "cd5_Region"]
      .filter(k => udo[k])
      .map(k => udo[k]).join(",");
    return ({
      tnm: `${udo.poiType}-${udo.content_group_2}`,
      continent: slugify(`${udo.cd1_Continent}`),
      ctt: slugify(`${udo.cd1_Continent}`),
      country: slugify(`${udo.cd2_Country}`),
      cnty: slugify(`${udo.cd2_Country}`),
      city: slugify(`${udo.cd3_City}`),
      destination: slugify(dest),
      dest: slugify(dest),
      layers: ["LonelyPlanet.com"],
      state: slugify(`${udo.cd5_Region}`),
      template: `${udo.poiType}-${udo.content_group_2}`,
      topic: `${udo.poiType}`,
      networkId: 9885583,
    });
  }
  return {};
};

 /**
 * Create an array of paths so that we can target DFP ads to Page URI's
 * @return Array an array of URL parts that can be targeted.
 */
function getUrlTargeting(url) {
  // Get the url and parse it to its component parts using regex from RFC2396 Appendix-B (https://tools.ietf.org/html/rfc2396#appendix-B)
  const reTag = /^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
  const urlMatches = (url || window.location.toString()).match(reTag);
  const matchedAuthority = urlMatches[4] || "";
  const matchedPath = (urlMatches[5] || "").replace(/(.)\/$/, "$1");
  const matchedQuery = urlMatches[7] || "";

  // Get the query params for targeting against
  const params = matchedQuery.replace(/=/ig, ":").split("&");

  return {
    Host: matchedAuthority,
    Path: matchedPath,
    Query: params,
  };
}

export function getAdData(data, url, krux) {
  const newData = _.omit(data, ["manager", "networkId", "layers"]);
  const adsUrlData = getUrlTargeting(url);
  const urlDataObj = {
    urlhost: adsUrlData.Host,
    urlpath: adsUrlData.Path,
    urlquery: adsUrlData.Query,
  };
  if (krux) {
    newData.ksg = krux.segments || "";
    newData.kuid = krux.user || "";
  }
  return Object.assign({}, newData, urlDataObj);
}



// WEBPACK FOOTER //
// ./assets/shared/utils/createAdTargeting.js